import { CredentialSchema } from '../../common/types';

const ROOT_URI = 'http://identity.com/schemas/';

export default class LocalSchemaLoader {
  private localSchemas: Record<string, CredentialSchema> = {};

  constructor(loadedSchemas: Record<string, CredentialSchema> = {}) {
    this.localSchemas = loadedSchemas;
  }

  private get schemas(): Record<string, CredentialSchema> {
    return this.localSchemas;
  }

  async loadSchema(identifier: string): Promise<CredentialSchema> {
    return this.schemas[identifier] as CredentialSchema;
  }

  async loadSchemaFromTitle(identifier: string): Promise<CredentialSchema> {
    return this.loadSchema(identifier);
  }

  valid(identifier: string): boolean {
    return !!this.schemas[identifier];
  }

  schemaId(identifier: string) {
    return ROOT_URI + identifier;
  }

  async flattenCredentialSchemaProperties(schema: { properties?: unknown; allOf?: { $ref: string }[] }) {
    const properties = schema.properties ? schema.properties : {};

    return properties;
  }
}
